const SectionCategoryLabel = ({ children }) => {
    return (
        <div className="max-w-2xl px-6">
            <h3 className="text-xl mb-2">{children}</h3>
        </div>
    );
};

export default SectionCategoryLabel;
